import styled, { DefaultTheme } from "styled-components";

interface IStyles {
    theme: DefaultTheme;
    isGiftcardFlow?: boolean;
}

const HEADER_HEIGHT = 52;

export const TopBar = styled.div({
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
});

export const FlexContainer = styled.div<IStyles>(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    whiteSpace: "nowrap",
    "& > *:not(:last-child)": {
        marginRight: theme.spacing.xxSmall,
    },
}));

const PADDING_HEADER = 2 * 16;

export const Header = styled.div<IStyles>(({ theme, isGiftcardFlow }) => ({
    display: "flex",
    top: 0,
    width: `calc(100% - ${PADDING_HEADER}px)`,
    minHeight: `${HEADER_HEIGHT}px`,
    height: `${HEADER_HEIGHT}px`,
    transition: "all 0.5s ease",
    margin: `0 ${theme.spacing.medium}`,
    background: isGiftcardFlow
        ? theme.colors[theme.colorMode].background_Primary
        : theme.colors[theme.colorMode].background_Secondary,
    zIndex: 2,
    padding: 0,
    position: "sticky",
}));

export const SvgContainer = styled.div(({ theme }) => ({
    marginRight: theme.spacing.xSmall,
}));

export const StyledHeader = styled(Header)<IStyles>(({ theme, isGiftcardFlow }) => ({
    borderBottom: isGiftcardFlow
        ? undefined
        : `1px solid ${theme.colors[theme.colorMode].background_Secondary_Alpha}`,
    "@supports (margin-top: var(--sat))": {
        paddingTop: "calc(var(--sat))",
        marginTop: 0,
        height: `calc(${HEADER_HEIGHT}px + var(--sat))`,
        minHeight: `calc(${HEADER_HEIGHT}px + var(--sat))`,
    },
}));
